module.exports = __webpack_public_path__ + "static/media/icon_form_edit.c2bca483.svg";